import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';

export function getRedisCache() {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CACHE_REDIS_GET,
        parser: data => cacheRedisDataParser(data),
    }).get();
}

export function deleteRedisCache(payload) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CACHE_REDIS_DELETE,
    }).post({ ...payload });
}

const cacheRedisDataParser = (data = {}) => {
    return {
        ...data.data
    }
};